var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.105 8.5C14.105 9.60453 13.2096 10.5 12.105 10.5C11.0004 10.5 10.105 9.60453 10.105 8.5C10.105 7.39543 11.0004 6.5 12.105 6.5C13.2096 6.5 14.105 7.39543 14.105 8.5Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.69501 13.6482C9.06623 14.0167 7.41759 14.7693 8.42172 15.711C8.91223 16.171 9.45853 16.5 10.1454 16.5H14.0646C14.7514 16.5 15.2978 16.171 15.7883 15.711C16.7924 14.7693 15.1438 14.0167 14.515 13.6482C13.0405 12.7839 11.1695 12.7839 9.69501 13.6482Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.105 11.1833V8.28029C21.105 6.64029 21.105 5.82028 20.7009 5.28529C20.2968 4.75029 19.3831 4.49056 17.5557 3.9711C16.3072 3.6162 15.2066 3.18863 14.3273 2.79829C13.1284 2.2661 12.529 2 12.105 2C11.681 2 11.0816 2.2661 9.88269 2.79829C9.00337 3.18863 7.90282 3.61619 6.65431 3.9711C4.82691 4.49056 3.9132 4.75029 3.50909 5.28529C3.10498 5.82028 3.10498 6.64029 3.10498 8.28029V11.1833C3.10498 16.8085 8.16775 20.1835 10.699 21.5194C11.3061 21.8398 11.6096 22 12.105 22C12.6004 22 12.9039 21.8398 13.511 21.5194C16.0422 20.1835 21.105 16.8085 21.105 11.1833Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.4d5f7f0110d2f2608a427767fd93bc0e.svg";
export { ForwardRef as ReactComponent };